import { ModalWindow, Switch, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IValuationFiltersMobileModalProps {
  isOpened?: boolean;
  mainFiltersWidget: JSX.Element;
  valuationFiltersSubmit: JSX.Element;
  valuationReady?: JSX.Element;
  valuationNotFound?: JSX.Element;
  onClose(): void;
  onPushToggle: (e: React.ChangeEvent, v: boolean) => void;
  pushValue: boolean;
  showPushToggle: boolean;
}

export const ValuationFiltersMobileModal: React.VFC<IValuationFiltersMobileModalProps> = ({
  mainFiltersWidget,
  valuationFiltersSubmit,
  valuationReady,
  valuationNotFound,
  onClose,
  isOpened,
  pushValue,
  onPushToggle,
  showPushToggle,
}) => {
  return (
    <ModalWindow
      open={isOpened}
      onClose={onClose}
      title="Оценка от Циан"
      content={
        <div className={styles['container']} data-name="valuation_form_modal">
          {mainFiltersWidget}
          {showPushToggle && (
            <div className={styles['push']}>
              <UIText1>Получать пуш-уведомления при изменении оценки</UIText1>
              <Switch data-name="push" checked={pushValue} onChange={onPushToggle} />
            </div>
          )}
          <div className={styles['message']}>
            {valuationReady}
            {valuationNotFound}
          </div>
          {valuationFiltersSubmit}
        </div>
      }
    />
  );
};
